export default {
      id: "i-arrow-accordion-usage",
      viewBox: "0 0 19 12",
      url: __webpack_public_path__ + "img/sprite.svg#i-arrow-accordion",
      toString: function () {
        return this.url;
      }
    }